/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";
import Link from "next/link";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import { useRecoilState } from "recoil";

import { engageCalendarMeetings } from "../../atoms/engage";
import { apiGetPublicCalendar } from "../../lib/api/engage";

import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";

dayjs.extend(isToday);

export default function MobileList({ client }) {
  const [year, setYear] = useState(dayjs().year());
  const [month, setMonth] = useState(dayjs().month());
  const [yearStr, setYearStr] = useState("");
  const [monthStr, setMonthStr] = useState("");
  const [meetings, setMeetings] = useRecoilState(engageCalendarMeetings);

  useEffect(() => {
    if (client) {
      async function fetchMeetings(month) {
        const result = await apiGetPublicCalendar(client, month);
        if (result) {
          setMeetings(result);
        }
      }
      const year = dayjs().year();
      const month = dayjs().month();
      setMonthStr(dayjs().month(month).format("MMMM"));
      setYearStr(dayjs().year(year).format("YYYY"));
      // api call to get meetings
      fetchMeetings(dayjs().toISOString());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  const handleMonthNavBack = async () => {
    let nextYear = year;
    let nextMonth = month - 1;
    if (nextMonth === -1) {
      nextMonth = 11;
      nextYear = year - 1;
    }
    setYear(nextYear);
    setMonth(nextMonth);
    setMonthStr(dayjs().month(nextMonth).format("MMMM"));
    setYearStr(dayjs().year(nextYear).format("YYYY"));
    // API call to get meetings
    setMeetings([]);
    const result = await apiGetPublicCalendar(
      client,
      dayjs(`${nextYear}-${nextMonth + 1}-01`).toISOString()
    );
    if (result) {
      setMeetings(result);
    }
  };

  const handleMonthNavForward = async () => {
    let nextYear = year;
    let nextMonth = month + 1;
    if (nextMonth === 12) {
      nextMonth = 0;
      nextYear = year + 1;
    }
    setYear(nextYear);
    setMonth(nextMonth);

    setMonthStr(dayjs().month(nextMonth).format("MMMM"));
    setYearStr(dayjs().year(nextYear).format("YYYY"));
    // api call to get meetings
    setMeetings([]);
    const result = await apiGetPublicCalendar(
      client,
      dayjs(`${nextYear}-${nextMonth + 1}-01`).toISOString()
    );
    if (result) {
      setMeetings(result);
    }
  };

  return (
    <div>
      <div className="flex items-center">
        <h2 className="flex-auto font-semibold text-gray-800 mt-2">
          {monthStr} {yearStr}
        </h2>
        <button
          type="button"
          className="mt-2 -my-1.5 flex flex-none items-center justify-center p-1.5 border-2 border-transparent text-gray-800 rounded-full"
          onClick={() => handleMonthNavBack()}
        >
          <ChevronLeftIcon className="h-6 w-6" aria-hidden="true" />
        </button>
        <button
          type="button"
          className="mt-2 -my-1.5 -mr-1.5 ml-2 flex flex-none items-center justify-center p-1.5 border-2 border-transparent text-gray-800 rounded-full"
          onClick={() => handleMonthNavForward()}
        >
          <ChevronRightIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>

      <div className="md:hidden overflow-hidden sm:rounded-md mt-2">
        <div>
          {meetings.map((meeting) => (
            <div key={meeting.id}>
              {(meeting.publishStatus === "published" ||
                meeting.publishStatus === "completed") && (
                <Link
                  href="/engage/[id]/[agenda]"
                  as={`/engage/${client}/${meeting.id}`}
                >
                  <a className="">
                    <div className="grid sm:grid-cols-2 px-4 py-4 bg-gray-100 mb-4 border border-gray-200 rounded-[20px]">
                      <div>
                        <p className="text-sm font-medium text-black truncate">
                          {meeting.meetingType}
                        </p>
                        <p className="mt-1 flex items-center text-sm text-gray-900">
                          <span className="truncate">
                            {meeting.scheduleDate}
                          </span>
                        </p>
                        <p className="mt-0.5 flex items-center font-light text-xs italic text-gray-900">
                          <span className="truncate">
                            {meeting.room.roomName}
                          </span>
                        </p>
                      </div>
                      <p className="mt-1 text-sm text-indigo-600">Agenda</p>
                    </div>
                  </a>
                </Link>
              )}
              {meeting.publishStatus === "draftreview" &&
                client === "broomfield" && (
                  <Link
                    href="/engage/[id]/[agenda]"
                    as={`/engage/${client}/${meeting.id}`}
                  >
                    <a className="">
                      <div className="grid sm:grid-cols-2 px-4 py-4 bg-gray-100 mb-4 border border-gray-200 rounded-[20px]">
                        <div>
                          <p className="text-sm font-medium text-black truncate">
                            {meeting.meetingType}
                          </p>
                          <p className="mt-1 flex items-center text-sm text-gray-900">
                            <span className="truncate">
                              {meeting.scheduleDate}
                            </span>
                          </p>
                          <p className="mt-0.5 flex items-center font-light text-xs italic text-gray-900">
                            <span className="truncate">
                              {meeting.room.roomName}
                            </span>
                          </p>
                        </div>
                        <p className="mt-1 text-sm text-indigo-600">
                          Draft Available
                        </p>
                      </div>
                    </a>
                  </Link>
                )}
              {meeting.publishStatus === "minutes" && (
                <Link
                  href="/engage/[client]/minutes/[minutes]"
                  as={`/engage/${client}/minutes/${meeting.id}`}
                >
                  <a className="">
                    <div className="grid sm:grid-cols-2 px-4 py-4 bg-gray-100 mb-4 border border-gray-200 rounded-[20px]">
                      <div>
                        <p className="text-sm font-medium text-black truncate">
                          {meeting.meetingType}
                        </p>
                        <p className="mt-1 flex items-center text-sm text-gray-900">
                          <span className="truncate">
                            {meeting.scheduleDate}
                          </span>
                        </p>
                        <p className="mt-0.5 flex items-center font-light text-xs italic text-gray-900">
                          <span className="truncate">
                            {meeting.room.roomName}
                          </span>
                        </p>
                      </div>
                      <p className="mt-1 text-sm text-indigo-600">Minutes</p>
                    </div>
                  </a>
                </Link>
              )}
              {meeting.publishStatus === "manualminutes" && (
                <Link
                  href="/engage/[client]/[agenda]"
                  as={`/engage/${client}/${meeting.id}`}
                >
                  <a className="">
                    <div className="grid sm:grid-cols-2 px-4 py-4 bg-gray-100 mb-4 border border-gray-200 rounded-[20px]">
                      <div>
                        <p className="text-sm font-medium text-black truncate">
                          {meeting.meetingType}
                        </p>
                        <p className="mt-1 flex items-center text-sm text-gray-900">
                          <span className="truncate">
                            {meeting.scheduleDate}
                          </span>
                        </p>
                        <p className="mt-0.5 flex items-center font-light text-xs italic text-gray-900">
                          <span className="truncate">
                            {meeting.room.roomName}
                          </span>
                        </p>
                      </div>
                      <p className="mt-1 text-sm text-indigo-600">Minutes</p>
                    </div>
                  </a>
                </Link>
              )}
              {meeting.publishStatus === "draft" && (
                <div className="grid sm:grid-cols-2 px-4 py-4 bg-gray-100 mb-4 border border-gray-200 rounded-[20px]">
                  <div>
                    <p className="text-sm font-medium text-black truncate">
                      {meeting.meetingType}
                    </p>
                    <p className="mt-1 flex items-center text-sm text-gray-900">
                      <span className="truncate">{meeting.scheduleDate}</span>
                    </p>
                    <p className="mt-0.5 flex items-center font-light text-xs italic text-gray-900">
                      <span className="truncate">{meeting.room.roomName}</span>
                    </p>
                  </div>

                  <p className="mt-1 text-sm text-black">Agenda Pending</p>
                </div>
              )}
              {meeting.publishStatus === "review" && (
                <Link
                  href="/engage/[id]/[agenda]"
                  as={`/engage/${client}/${meeting.id}`}
                >
                  <a>
                    <div className="grid sm:grid-cols-2 px-4 py-4 bg-gray-100 mb-4 border border-gray-200 rounded-[20px]">
                      <div>
                        <p className="text-sm font-medium text-black truncate">
                          {meeting.meetingType}
                        </p>
                        <p className="mt-1 flex items-center text-sm text-gray-900">
                          <span className="truncate">
                            {meeting.scheduleDate}
                          </span>
                        </p>
                        <p className="mt-0.5 flex items-center font-light text-xs italic text-gray-900">
                          <span className="truncate">
                            {meeting.room.roomName}
                          </span>
                        </p>
                      </div>

                      <p className="mt-1 text-sm text-gray-400">Agenda</p>
                    </div>
                  </a>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
